/* Slab collection facet filter — client-side, over server-rendered cards.
   Buckets ported from the design prototype (pages-collection.jsx). */
(function () {
  'use strict';
  // Collection-switcher (Slabs) dropdown — runs on every collection page,
  // including porcelain/modular pages that render no facet bar.
  (function () {
    var kt = document.querySelector('[data-kind-toggle]');
    var kd = document.querySelector('[data-kind-dropdown]');
    if (!kt || !kd) return;
    var mq = window.matchMedia('(max-width: 768px)');
    // On mobile the dropdown is position:fixed (so the horizontal-scroll tab row
    // can't clip it) — anchor it just below the Slabs tab.
    function position() {
      if (mq.matches) { kd.style.top = Math.round(kt.getBoundingClientRect().bottom) + 'px'; }
      else { kd.style.top = ''; }
    }
    kt.addEventListener('click', function () {
      var willOpen = kd.hidden;
      kd.hidden = !willOpen;
      kt.setAttribute('aria-expanded', String(willOpen));
      if (willOpen) position();
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-kind-wrap]')) kd.hidden = true;
    });
    window.addEventListener('resize', function () { if (!kd.hidden) position(); });
  })();

  var root = document.querySelector('[data-collection-filter]');
  var grid = document.querySelector('[data-product-grid]');
  if (!root || !grid) return;

  var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product]'));
  var resultEl = root.querySelector('[data-result-count]');
  var activeEl = root.querySelector('[data-active-filters]');
  var emptyEl = document.querySelector('[data-empty]');
  var sortSel = root.querySelector('[data-sort]');
  var searchInput = root.querySelector('[data-search-input]');
  var searchTerm = '';

  // ── Sorting / filtering across the whole collection, not just the loaded page ──
  // Infinite scroll only puts the first page of cards on screen, so sorting or
  // filtering in the browser alone would only cover those. Sorts Shopify can do
  // itself reload the collection with ?sort_by= (infinite scroll then keeps that
  // order as it loads more pages). The slab-specific sorts (lot, stock,
  // thickness), filters and search load every remaining page first.
  var SERVER_SORT = {
    'featured': null,
    'new': 'created-descending',
    'name': 'title-ascending',
    'price-asc': 'price-ascending',
    'price-desc': 'price-descending'
  };
  function isServerSort(mode) { return Object.prototype.hasOwnProperty.call(SERVER_SORT, mode); }

  function cardKey(card) {
    var link = card.querySelector('a[href]');
    return link ? link.getAttribute('href') : card.getAttribute('data-name');
  }
  var seen = {};
  cards.forEach(function (c) { seen[cardKey(c)] = true; });
  function addCards(fresh) {
    fresh.forEach(function (card) {
      var key = cardKey(card);
      if (seen[key]) return;
      seen[key] = true;
      grid.appendChild(card);
      requestAnimationFrame(function () { card.classList.add('is-in'); });
      cards.push(card);
    });
  }

  function hasMorePages() {
    var a = document.querySelector('[data-next-page]');
    return !!(a && a.getAttribute('href'));
  }
  var loadingAll = null;
  function loadAllPages() {
    if (loadingAll) return loadingAll;
    if (resultEl) resultEl.textContent = 'Loading all slabs…';
    function next() {
      var a = document.querySelector('[data-next-page]');
      var url = a && a.getAttribute('href');
      if (!url) return Promise.resolve();
      a.removeAttribute('href'); // claim the page so infinite scroll doesn't fetch it too
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextA = doc.querySelector('[data-next-page]');
          if (nextA && nextA.getAttribute('href')) a.setAttribute('href', nextA.getAttribute('href'));
          addCards(Array.prototype.slice.call(doc.querySelectorAll('[data-product-grid] [data-product]')));
          return next();
        });
    }
    loadingAll = next()
      .catch(function () {})
      .then(function () { loadingAll = null; });
    return loadingAll;
  }
  function needsAllPages() {
    if (searchTerm) return true;
    if (sortSel && !isServerSort(sortSel.value)) return true;
    return Object.keys(state).some(function (k) { return state[k].length > 0; });
  }

  // ── Bucket helpers (verbatim logic from prototype) ──
  // Size filter splits into Length (longest side) + Width (shortest side); both minimums.
  function parseDims(card) {
    var dim = card.getAttribute('data-dimensions');
    if (!dim) return null;
    var m = dim.match(/(\d+(?:\.\d+)?)\s*["'’”]?\s*[x×]\s*(\d+(?:\.\d+)?)/i);
    if (!m) return null;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    return { len: Math.max(a, b), wid: Math.min(a, b) };
  }
  function cardLen(card) { var d = parseDims(card); return d ? d.len : 0; }
  function cardWid(card) { var d = parseDims(card); return d ? d.wid : 0; }
  function thicknessBucket(t) {
    if (!t) return 'Other';
    var n = parseFloat(t);
    if (isNaN(n)) return t;
    if (n <= 1.5) return '1 cm';
    if (n <= 2.5) return '2 cm';
    if (n <= 3.5) return '3 cm';
    return '+3 cm';
  }
  function priceBucket(pr) {
    pr = parseInt(pr, 10);
    if (isNaN(pr) || pr <= 0) return null; // gated / unknown → excluded from facet
    var d = pr / 100;
    if (d < 50) return 'Tier I';
    if (d < 120) return 'Tier II';
    if (d < 220) return 'Tier III';
    return 'Tier IV';
  }
  function priceCatBucket(pr) {
    pr = parseInt(pr, 10);
    if (isNaN(pr) || pr <= 0) return null;
    // pr is per-slab price in cents
    if (pr < 150000)  return '1'; // under $1,500
    if (pr < 300000)  return '2'; // $1,500–$3,000
    if (pr < 500000)  return '3'; // $3,000–$5,000
    if (pr < 750000)  return '4'; // $5,000–$7,500
    if (pr < 1100000) return '5'; // $7,500–$11,000
    return '6';                    // $11,000+
  }
  function priceCatFor(card) {
    // metafield-backed category (set by merch team) wins; only compute
    // from live price when the product has no category assigned.
    var cat = card.getAttribute('data-category');
    if (cat) return cat;
    return priceCatBucket(card.getAttribute('data-price'));
  }

  var LENGTH_OPTS = ['100"+', '110"+', '120"+', '130"+', '140"+']; // minimum longest side
  var WIDTH_OPTS  = ['60"+', '65"+', '70"+', '75"+', '80"+'];       // minimum shortest side
  var THICK_ORDER = ['1 cm', '2 cm', '3 cm', '+3 cm'];
  var STOCK_OPTS  = ['2+', '5+', '10+', '15+'];   // minimum slabs available
  var PRICE_ORDER = ['Tier I', 'Tier II', 'Tier III', 'Tier IV'];

  // A card can carry several finishes ("Polished, Honed") — split into individual values.
  function cardFinishes(card) {
    return (card.getAttribute('data-finish') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  // facet key → { bucket fn from a card, ordered options }
  // dynamic: options are the distinct values present (alphabetical), hidden unless there's a real choice
  // multi:   fn returns an array of values; a card matches when any selected value is present
  var FACETS = {
    type:      { dynamic: true, fn: function (c) { return c.getAttribute('data-type') || null; } },
    size:      { split: true }, /* Length + Width two-column panel — custom-rendered & matched */
    finish:    { dynamic: true, multi: true, fn: cardFinishes },
    stock:     { min: true },
    thickness: { fn: function (c) { return thicknessBucket(c.getAttribute('data-thickness')); }, order: THICK_ORDER },
    price:     { fn: function (c) { return priceBucket(c.getAttribute('data-price')); }, order: PRICE_ORDER },
    pricecat:  { fn: priceCatFor, order: ['1','2','3','4','5','6'] }
  };

  var state = { type: [], sizeL: [], sizeW: [], finish: [], stock: [], thickness: [], price: [], pricecat: [] };

  function optionsFor(key) {
    var f = FACETS[key];
    var present = {};
    cards.forEach(function (c) {
      var b = f.fn(c);
      (Array.isArray(b) ? b : [b]).forEach(function (v) { if (v) present[v] = true; });
    });
    if (f.dynamic) return Object.keys(present).sort();
    return f.order.filter(function (o) { return present[o]; });
  }

  function cardMatches(card) {
    if (searchTerm) {
      var name = (card.getAttribute('data-name') || '').toLowerCase();
      if (name.indexOf(searchTerm) === -1) return false;
    }
    return Object.keys(state).every(function (key) {
      var sel = state[key];
      if (!sel.length) return true;
      if (key === 'sizeL') return cardLen(card) >= parseInt(sel[0], 10); // length = longest side ≥
      if (key === 'sizeW') return cardWid(card) >= parseInt(sel[0], 10); // width = shortest side ≥
      if (key === 'stock') return (parseInt(card.getAttribute('data-stock'), 10) || 0) >= parseInt(sel[0], 10);
      var b = FACETS[key].fn(card);
      if (Array.isArray(b)) return b.some(function (v) { return sel.indexOf(v) !== -1; });
      return b && sel.indexOf(b) !== -1;
    });
  }

  function apply() {
    var visible = 0;
    cards.forEach(function (card) {
      var show = cardMatches(card);
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    if (resultEl) resultEl.textContent = visible + (visible === 1 ? ' slab' : ' slabs');
    if (emptyEl) emptyEl.hidden = visible !== 0;
    sortCards();
    renderActive();
    if (needsAllPages() && hasMorePages() && !loadingAll) loadAllPages().then(function () { renderPanels(); apply(); });
  }

  function sortCards() {
    var mode = sortSel ? sortSel.value : 'featured';
    if (isServerSort(mode)) return; // already in the right order from Shopify (?sort_by=)
    var arr = cards.slice();
    arr.sort(function (a, b) {
      if (mode === 'name') return a.getAttribute('data-name').localeCompare(b.getAttribute('data-name'));
      if (mode === 'lot') return (parseInt(a.getAttribute('data-lot'), 10) || 0) - (parseInt(b.getAttribute('data-lot'), 10) || 0);
      if (mode === 'lot-desc') return (parseInt(b.getAttribute('data-lot'), 10) || 0) - (parseInt(a.getAttribute('data-lot'), 10) || 0);
      if (mode === 'stock-desc') return (parseInt(b.getAttribute('data-stock'), 10) || 0) - (parseInt(a.getAttribute('data-stock'), 10) || 0);
      if (mode === 'thickness-asc') return (parseFloat(a.getAttribute('data-thickness')) || 0) - (parseFloat(b.getAttribute('data-thickness')) || 0);
      if (mode === 'thickness-desc') return (parseFloat(b.getAttribute('data-thickness')) || 0) - (parseFloat(a.getAttribute('data-thickness')) || 0);
      if (mode === 'price-asc') return (parseInt(a.getAttribute('data-price'), 10) || 0) - (parseInt(b.getAttribute('data-price'), 10) || 0);
      if (mode === 'price-desc') return (parseInt(b.getAttribute('data-price'), 10) || 0) - (parseInt(a.getAttribute('data-price'), 10) || 0);
      if (mode === 'new') return (parseInt(b.getAttribute('data-created'), 10) || 0) - (parseInt(a.getAttribute('data-created'), 10) || 0);
      return 0;
    });
    arr.forEach(function (c) { grid.appendChild(c); });
  }

  var KEY_LABEL = {};
  function esc(s) { return String(s).replace(/"/g, '&quot;'); }
  function renderActive() {
    if (!activeEl) return;
    var chips = [];
    Object.keys(state).forEach(function (key) {
      state[key].forEach(function (v) { chips.push({ key: key, val: v }); });
    });
    if (!chips.length) { activeEl.hidden = true; activeEl.innerHTML = ''; return; }
    activeEl.hidden = false;
    activeEl.style.cssText = 'display:flex;gap:8px;flex-wrap:wrap;margin-top:12px;';
    activeEl.innerHTML = chips.map(function (c) {
      var label = (KEY_LABEL[c.key] || '') + c.val.replace(/"/g, '');
      return '<button class="facet-chip" data-remove data-key="' + c.key + '" data-val="' + esc(c.val) + '" style="border:1px solid var(--c-rule);padding:6px 12px;font-family:var(--font-sub);font-size:10px;letter-spacing:0.2em;text-transform:uppercase;background:none;cursor:pointer;">' + label + ' ×</button>';
    }).join('') + '<button data-clear-all style="border:none;background:none;font-family:var(--font-sub);font-size:10px;letter-spacing:0.2em;text-transform:uppercase;text-decoration:underline;cursor:pointer;">Clear all</button>';
  }

  // Build facet panels. Option lists come from the cards on the page, so they're
  // rebuilt as more pages arrive — opening any facet loads every remaining page
  // first, so the lists cover the whole collection, not just the first page.
  function thresholdOpts(opts, fn) {
    return opts.filter(function (o) { var t = parseInt(o, 10); return cards.some(function (c) { return fn(c) >= t; }); });
  }
  function renderPanel(btn) {
    var key = btn.getAttribute('data-facet');
    if (!FACETS[key]) { btn.style.display = 'none'; return; }
    var panel = btn.querySelector('[data-facet-panel]');
    var html;

    if (key === 'size') {
      // Two single-select columns: Length (longest side) + Width (shortest side)
      var lenOpts = thresholdOpts(LENGTH_OPTS, cardLen);
      var widOpts = thresholdOpts(WIDTH_OPTS, cardWid);
      if (!lenOpts.length && !widOpts.length) { btn.style.display = 'none'; return; }
      var col = function (title, axis, opts) {
        return '<div class="facet-col"><div class="facet-col__head">' + title + '</div>' +
          opts.map(function (o) {
            return '<label><input type="checkbox" data-axis="' + axis + '" value="' + o.replace(/"/g, '&quot;') + '"> ' + o.replace(/"/g, '') + '</label>';
          }).join('') + '</div>';
      };
      panel.classList.add('facet-panel--size');
      html = '<div class="facet-size">' + col('Length', 'L', lenOpts) + col('Height', 'W', widOpts) + '</div>';
    } else if (key === 'stock') {
      var stkOpts = STOCK_OPTS.filter(function (o) {
        var t = parseInt(o, 10);
        return cards.some(function (c) { return (parseInt(c.getAttribute('data-stock'), 10) || 0) >= t; });
      });
      if (!stkOpts.length) { btn.style.display = 'none'; return; }
      html = stkOpts.map(function (o) {
        return '<label><input type="checkbox" data-stock-min value="' + o + '"> ' + o + '</label>';
      }).join('');
    } else {
      var opts = optionsFor(key);
      // hide a facet with no options; hide dynamic facets (Stone Type, Finish) unless there's an actual choice (2+ values)
      if (!opts.length || (FACETS[key].dynamic && opts.length < 2)) { btn.style.display = 'none'; return; }
      html = opts.map(function (o) {
        return '<label><input type="checkbox" value="' + o.replace(/"/g, '&quot;') + '"> ' + o + '</label>';
      }).join('');
    }
    btn.style.display = '';
    if (panel.innerHTML !== html) panel.innerHTML = html;
  }
  function renderPanels() {
    root.querySelectorAll('[data-facet]').forEach(renderPanel);
    syncChecks();
  }

  // Wire each facet once; the change listeners sit on the panel itself, so they
  // survive renderPanel() replacing the options inside it.
  root.querySelectorAll('[data-facet]').forEach(function (btn) {
    var key = btn.getAttribute('data-facet');
    if (!FACETS[key]) return;
    var panel = btn.querySelector('[data-facet-panel]');
    var countEl = btn.querySelector('[data-facet-count]');

    // open/close (shared by all facets)
    btn.addEventListener('click', function (e) {
      if (e.target.closest('[data-facet-panel]')) return;
      var open = !panel.hidden;
      root.querySelectorAll('[data-facet-panel]').forEach(function (p) { p.hidden = true; });
      panel.hidden = open;
      if (!open && hasMorePages()) loadAllPages().then(function () { renderPanels(); apply(); });
    });

    if (key === 'size') {
      panel.addEventListener('change', function (e) {
        var axis = e.target.getAttribute('data-axis');
        if (!axis) return;
        var stKey = axis === 'L' ? 'sizeL' : 'sizeW';
        if (e.target.checked) {
          // single-select within the column (a minimum is one floor)
          state[stKey] = [e.target.value];
          panel.querySelectorAll('input[data-axis="' + axis + '"]').forEach(function (cb) { if (cb !== e.target) cb.checked = false; });
        } else { state[stKey] = []; }
        if (countEl) { var n = state.sizeL.length + state.sizeW.length; countEl.textContent = n; countEl.hidden = n === 0; }
        apply();
      });
      return;
    }

    if (key === 'stock') {
      panel.addEventListener('change', function (e) {
        if (!e.target.hasAttribute('data-stock-min')) return;
        if (e.target.checked) {
          state.stock = [e.target.value];
          panel.querySelectorAll('input[data-stock-min]').forEach(function (cb) { if (cb !== e.target) cb.checked = false; });
        } else { state.stock = []; }
        if (countEl) { countEl.textContent = state.stock.length; countEl.hidden = state.stock.length === 0; }
        apply();
      });
      return;
    }

    panel.addEventListener('change', function (e) {
      var v = e.target.value;
      if (e.target.checked) { if (state[key].indexOf(v) === -1) state[key].push(v); }
      else { state[key] = state[key].filter(function (x) { return x !== v; }); }
      if (countEl) { countEl.textContent = state[key].length; countEl.hidden = state[key].length === 0; }
      apply();
    });
  });
  renderPanels();

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-remove]')) {
      var b = e.target.closest('[data-remove]');
      var key = b.getAttribute('data-key'), val = b.getAttribute('data-val');
      state[key] = state[key].filter(function (x) { return x !== val; });
      syncChecks(); apply();
    }
    if (e.target.closest('[data-clear-all]') || e.target.closest('[data-clear-filters]')) {
      Object.keys(state).forEach(function (k) { state[k] = []; });
      syncChecks(); apply();
    }
    if (!e.target.closest('[data-facet]')) {
      root.querySelectorAll('[data-facet-panel]').forEach(function (p) { p.hidden = true; });
    }
  });

  function syncChecks() {
    root.querySelectorAll('[data-facet]').forEach(function (btn) {
      var key = btn.getAttribute('data-facet');
      var countEl = btn.querySelector('[data-facet-count]');
      if (key === 'size') {
        btn.querySelectorAll('input[data-axis]').forEach(function (cb) {
          var stKey = cb.getAttribute('data-axis') === 'L' ? 'sizeL' : 'sizeW';
          cb.checked = state[stKey].indexOf(cb.value) !== -1;
        });
        if (countEl) { var n = state.sizeL.length + state.sizeW.length; countEl.textContent = n; countEl.hidden = n === 0; }
        return;
      }
      btn.querySelectorAll('input[type=checkbox]').forEach(function (cb) {
        cb.checked = state[key] && state[key].indexOf(cb.value) !== -1;
      });
      if (countEl && state[key]) { countEl.textContent = state[key].length; countEl.hidden = state[key].length === 0; }
    });
  }

  if (sortSel) {
    // Reflect a server-side sort (?sort_by=) in the dropdown after the reload.
    var currentSort = new URL(window.location.href).searchParams.get('sort_by');
    Object.keys(SERVER_SORT).forEach(function (mode) {
      if (currentSort && SERVER_SORT[mode] === currentSort) sortSel.value = mode;
    });
    sortSel.addEventListener('change', function () {
      var mode = sortSel.value;
      if (isServerSort(mode)) {
        var url = new URL(window.location.href);
        url.searchParams.delete('page');
        if (SERVER_SORT[mode]) url.searchParams.set('sort_by', SERVER_SORT[mode]);
        else url.searchParams.delete('sort_by');
        window.location.href = url.toString();
        return;
      }
      apply();
    });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      searchTerm = searchInput.value.trim().toLowerCase();
      apply();
    });
    searchInput.addEventListener('search', function () {
      searchTerm = searchInput.value.trim().toLowerCase();
      apply();
    });
  }

  // Infinite scroll integration: register newly loaded cards and re-apply filters
  document.addEventListener('collection:newcards', function (e) {
    e.detail.cards.forEach(function (c) {
      var key = cardKey(c);
      if (seen[key]) return;
      seen[key] = true;
      cards.push(c);
    });
    renderPanels();
    apply();
  });

  apply();
})();
